import React from 'react';

export const PATRIMONY_OPTIONS = {
    WORK: {
        label: 'field-income_item_a_1',
        model: 'userProfile.capital_work',
        onChangeData: {
            value: 'work',
            key: '01',
        },
        errorMessageComponent: <></>,
    },
    ACTIVITIES: {
        label: 'field-income_item_a_2',
        model: 'userProfile.capital_activities',
        onChangeData: {
            value: 'activities',
            key: '02',
        },
        errorMessageComponent: <></>,
    },
    HERITAGE: {
        label: 'field-income_item_a_3',
        model: 'userProfile.capital_heritage',
        onChangeData: {
            value: 'heritage',
            key: '03',
        },
        errorMessageComponent: <></>,
    },
    BUSINESS: {
        label: 'field-income_item_a_4',
        model: 'userProfile.capital_business',
        onChangeData: {
            value: 'business',
            key: '04',
        },
        errorMessageComponent: <></>,
    },
    REAL_STATE: {
        label: 'field-income_item_a_5',
        model: 'userProfile.capital_realState',
        onChangeData: {
            value: 'realState',
            key: '05',
        },
        errorMessageComponent: <></>,
    },
    GAMES_OF_CHANCE: {
        label: 'field-income_item_a_6',
        model: 'userProfile.capital_gamesOfChance',
        onChangeData: {
            value: 'gamesOfChance',
            key: '06',
        },
        errorMessageComponent: <></>,
    },
    OTHER: {
        label: 'field-income_item_a_7',
        model: 'userProfile.capital_other',
        onChangeData: {
            value: 'other',
            key: '07',
        },
        errorMessageComponent: <></>,
    },
};
